__turbopack_context__.v({
  "bold": "lAVX_q_bold",
  "bottom": "lAVX_q_bottom",
  "columns": "lAVX_q_columns",
  "container": "lAVX_q_container",
  "label": "lAVX_q_label",
  "notes": "lAVX_q_notes",
  "row": "lAVX_q_row",
  "top": "lAVX_q_top",
});
